import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

export default class Privacy extends Component {

  render() {
    const { route } = this.props;

    let url = route.meta.site_url;
    let owner = route.meta.site_owner;
    let site_name = route.meta.site_name;

    let scope = (
        <div>
            <h3>Scope</h3>
            <p>
            This statement applies to all { url } visitors, unless a separate privacy notice is prominently displayed.
            </p>
        </div>
    )

    let account_information = (
        <div>
            <h3>Account Information</h3> 
            <p>
            You don’t have to create an account to access some features on { site_name }. If you do choose to create an account, you must provide us with some Personally Identifiable Information for the purpose of providing the Service, identifying and communicating with you, responding to your requests/enquiries and improving our services. Personally Identifiable Information may include, but is not limited to, your email address, username, phone number and address. For your username you may use either your real name or a pseudonym of your choice.
            </p>
        </div>
    )

    let public_information = (
        <div>
            <h3>Public Information</h3>
            <p>
            Most activity on { site_name } is public. This includes your profile information such as username and when you created your account, any content you post, including but not limited to audio recordings, and any content you save, upvote or downvote on { site_name }. What you share is publicly available worldwide, and may appear on other media including, but not limited to websites, newspapers, radio and television. 
            </p>
        </div>
    )

    let communications = (
        <div>
            <h3>Communications</h3>
            <p>
            We may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send.
            </p>
        </div>
    )

    let aggregated_data = (
        <div>
            <h3>Aggregated Data</h3>
            <p>
            We reserve the right to share or disclose aggregated, non-personal data, such as the number of people who visited the site during a period of time or engaged with a piece of content. We may also share reports with advertisers about how many people saw, clicked, interacted or listened to one of their advertisements. 
            </p>
        </div>
    )

    let google_analytics = (
        <div>
            <h3>Google Analytics</h3>
            <p>
            Like millions of other website owners, we use Google Analytics on { url }. Google Analytics is a piece of software that grabs data about visitors to this site. It’s something like an advanced server log. It will record what website you came from to get here and what kind of computer you’re using among other things. The tracking information allows us to better understand the kind of people who come to our site and what content they’re viewing. This allows us to make better decisions about improving this website. Occasionally, we will compile aggregate statistics about the number of visitors this site receives and browsers being used. No personally identifying data is included in this type of reporting. All data collected by Google Analytics is stored and maintained by Google, not us. All of our activity falls within the bounds of the Google Analytics Terms of Service.     
            </p>
            
        </div>
    )

    let legal_requests = (
        <div>
            <h3>Legal Requests</h3>
            <p>
            We reserve the right to preserve, use, or disclose your personal data if we believe it is reasonably necessary to comply with a law, regulation, legal process or government request.
            </p>
        </div>
    )

    let change_of_ownership = (
        <div>
            <h3>Change of ownership</h3>
            <p>
            If {site_name} is involved in an event such as merger, acquisition, reorganization, bankruptcy or sale of assets, your personal data may be sold or transferred as part of that transaction. This privacy policy will still apply to any data that is transferred to a new entity. 
            </p>
        </div>
    )

    let policy_revisions = (
        <div>
            <h3>Policy Revisions</h3>
            <p>
            Occasionally we may revise our Privacy Policy. If we make a change to this policy that, in our sole discretion, is material, we will notify you by emailing the email address associated with your account or by displaying a banner on the site notifying you of such changes. The most current version of our policy will govern how your data is processed and handled. 
            </p>
        </div>
    )

    return (
      <div className="Privacy">
        <Helmet
          title={this.props.route.meta.site_name}
          meta={ [
            { name: "description", content: this.props.route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <h1>Privacy Policy</h1>
        <Link to="/">Return home</Link>
        
        {scope}
        {account_information}
        {public_information}
        {communications}
        {aggregated_data}
        {google_analytics}
        {legal_requests}
        {change_of_ownership}
        {policy_revisions}

        <p>
        Last Updated 07/12/2018
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Privacy/Privacy.js